<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-11">
        <div class="">
          <div class="card-body d-flex flex-column p-0 pb-10">
            <div class="row">
              <div class="col-12 col-md-9 font-weight-bolder font-size-h3 mb-8">
                VideoBlog
              </div>
              <div class="col-12 col-md-3 text-right">
                <router-link
                  :to="'/videoblog/add/' + me._id"
                  class="btn btn-success"
                  >Add Videotutorial</router-link
                >
              </div>
            </div>
            <div class="tutorials row">
              <div
                class=" col-12 col-lg-4 col-md-4 col-sm-6"
                v-for="v of tutorials"
                :key="v._id"
              >
                <div class="card p-0">
                  <router-link :to="'/videoblog/' + v._id">
                    <div
                      class="cover"
                      v-bind:style="{
                        backgroundImage:
                          'url(http://img.youtube.com/vi/' +
                          getVideoId(v.videoUrl) +
                          '/0.jpg)'
                      }"
                    >
                      <div class="likes">
                        <span>
                          <i class="red fa fa-thumbs-up"></i
                          >{{ v.likes.length }}
                        </span>
                        <span>
                          <i class="fa fa-comment"></i>{{ v.comments.length }}
                        </span>
                      </div>
                    </div>
                    <div class="info p-5">
                      <h2 class="mb-4">{{ v.title }}</h2>
                      <div class="tags">
                        <span
                          class="badge badge-success mr-2"
                          v-for="t of v.tags"
                          :key="t._id"
                        >
                          {{ getTagInfo(t) }}
                        </span>
                      </div>
                      <div
                        class="users symbol-group"
                        v-if="!v.teams.length > 0"
                      >
                        <span
                          class="symbol symbol-circle symbol-50px"
                          v-for="u of v.users"
                          :key="u._id"
                        >
                          <img :src="getUserPhoto(u)" />
                          <span class="user-name">{{ getUserName(u) }}</span>
                        </span>
                      </div>
                      <div class="users symbol-group" v-else>
                        <span
                          class="symbol symbol-circle symbol-50px"
                          v-for="u of v.teams"
                          :key="u._id"
                        >
                          <img :src="getTeamPhoto(u)" />
                          <span class="user-name">{{ getTeamName(u) }}</span>
                        </span>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
//import axios from "axios";

export default {
  name: "all-paths",
  components: {},
  data() {
    return {};
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "VideoBlog", subtitle: "All video tutorials" }
    ]);
  },
  computed: {
    tutorials() {
      return this.$store.getters.getTutorials;
    },
    tags() {
      return this.$store.getters.getTags;
    },
    users() {
      return this.$store.getters.getUsers;
    },
    teams() {
      return this.$store.getters.getTeams;
    },
    me() {
      return this.$store.getters.getMyUser;
    },
    projects() {
      return this.$store.getters.getProjects;
    },
    activeProjects() {
      return this.projects.filter(p => p.isActive);
    }
  },
  methods: {
    getVideoId(url) {
      console.log(url);
      let ID = "";
      url = url
        .replace(/(>|<)/gi, "")
        .split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
      if (url[2] !== undefined) {
        ID = url[2].split(/[^0-9a-z_-]/i);
        ID = ID[0];
      } else {
        ID = url;
      }
      console.log(ID);
      return ID;
    },
    getUserName(u) {
      let username = this.users.find(user => user._id == u);
      return username?.firstName + " " + username?.lastName;
    },
    getUserPhoto(u) {
      let user = this.users.find(user => user._id == u);
      return user?.avatar
        ? process.env.VUE_APP_API_URL + user.avatar
        : "/media/svg/avatars/001-boy.svg";
    },
    getTeamName(u) {
      let team = this.teams.find(user => user._id == u);
      return team?.name;
    },
    getTeamPhoto(u) {
      let team = this.teams.find(user => user._id == u);
      return team?.logo
        ? process.env.VUE_APP_API_URL + team.logo
        : "/media/svg/avatars/001-boy.svg";
    },
    getTagInfo(t) {
      let tag = this.tags.find(tag => tag._id == t);
      return tag?.name;
    }
  }
};
</script>

<style lang="scss">
.tutorials {
  .card {
    border: 0;
    overflow: hidden;
    transition: all 0.5s;
    &:hover {
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }
    .cover {
      aspect-ratio: 16 / 8;
      background-position: center center;
      background-size: cover;
      filter: grayscale(0.55);
      transition: all 0.5s ease-in-out;
      position: relative;
      &:hover {
        filter: grayscale(0);
      }
      .likes {
        position: absolute;
        bottom: 10px;
        right: 10px;
        span {
          border-radius: 3px;
          background: rgb(0, 0, 0);
          padding: 5px 8px;
          font-size: 12px;
          font-weight: 700;
          display: inline-block;
          margin-left: 3px;
          color: white;
          i {
            margin-right: 5px;
            font-size: 12px;
            color: white;
            &.red {
              color: #f14850;
            }
          }
        }
      }
    }
    .users {
      margin-top: 10px;
      .symbol {
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
        background: white;
        aspect-ratio: 1/1;
        display: flex;
        align-items: center;
        img {
          width: 100%;
          height: auto;
        }
        .user-name {
          position: absolute;
          top: -20px;
          left: -15px;
          font-size: 8px;
          width: 80px;
          max-width: 100px;
          background: rgba(0, 0, 0, 0.7);
          border-radius: 3px;
          padding: 3px 5px;
          text-align: center;
          display: none;
          color: white;
        }
        &:hover {
          .user-name {
            display: inline-block;
          }
        }
      }
    }
    .info {
      h2 {
        font-size: 17px;
        color: #333;
      }
      .tags {
        span {
          font-size: 10px;
        }
      }
    }
  }
}
</style>
